export default "__VITE_ASSET__KI$UsEXs__"